<template>
  <card class="w-100">
    <el-row :gutter="10">
      <form @submit.prevent="searchStore()">
        <el-col :span="4">
          <div class="form-group">
            <label>지역</label>
            <el-select v-model="searchAreaSeq" placeholder="지역" @change="changeArea">
              <el-option
                key=""
                label="전체"
                value="">
              </el-option>
              <el-option
                v-for="item in $store.state.store.areas"
                :key="item.areaSeq"
                :label="item.areaName"
                :value="item.areaSeq">
              </el-option>
            </el-select>
          </div>

        </el-col>
        <el-col :span="8">
          <div class="form-group">
            <label>점포</label>
            <el-select v-model="selectedStoreSeq" filterable placeholder="점포선택">
              <el-option
                key=""
                label="전체"
                value="">
              </el-option>
              <el-option
                v-for="item in $store.state.store.stores"
                :key="item.storeSeq"
                :label="item.storeName"
                :value="item.storeSeq">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="pull-right-top24">
            <el-button type="primary" @click="resetPage" icon="el-icon-refresh">초기화</el-button>
            <!--<el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>-->
          </div>
        </el-col>
      </form>
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  ref="storeTable"
                  style="width: 100%; margin-bottom: 10px"
                  :data="filterData"
                  :header-cell-style="tableRowStyle">
          <el-table-column v-for="column in tableColumns"
                           :key="column.label"
                           :min-width="column.minWidth"
                           :prop="column.prop"
                           sortable
                           :label="column.label">
          </el-table-column>
          <el-table-column
            sortable
            prop="storeNumber"
            label="호수">
            <template slot-scope="props">
              {{ props.row.storeNumber }} 호점
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="openDate"
            label="오픈일">
            <template slot-scope="props">
              {{ props.row.openDate | moment('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="closeDate"
            label="패점일">
            <template slot-scope="props">
              {{ props.row.closeDate !== undefined ? getDateText(props.row.closeDate) : "-" }}
            </template>
          </el-table-column>
          <el-table-column
            label="관리"
            width="150">
            <template slot-scope="props">
              <el-button type="danger" icon="el-icon-delete-solid" @click="handleRemove(props.$index, props.row)" v-if="checkAuth($store.state.account.roleCode, 'ADMIN')"></el-button>
              <el-button type="primary" icon="el-icon-edit" @click="handleEdit(props.$index, props.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-shopping-bag-1" v-on:click="storeRegistration">신규 점포</el-button>
        </div>
      </el-col>
    </el-row>
  </card>
</template>

<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, Button, Row, Col} from 'element-ui'
  import VueMoment from 'vue-moment'
  import StoreProxy from "@/proxies/StoreProxy";
  import moment from 'moment-timezone'

  Vue.use(VueMoment, {
    moment,
  })

  Vue.use(VueMoment)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)

  export default {
    name: "StoreManagement",
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "점포 정보");
      this.$store.dispatch('store/getAreaList');
      this.searchStore();
    },
    updated: function () {
      this.$refs.storeTable.doLayout();
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      storeRegistration() {
        Vue.router.push({name: 'StoreRegistration'});
      },
      handleEdit(index, row) {
        Vue.router.push({name: 'StoreEdit', params: {storeSeq: row.storeSeq}});
      },
      handleRemove(index, row) {
        if(confirm("해당 매장을 삭제하시면 층과 광고도 같이 삭제됩니다.\n삭제하시겠습니까?")) {
          new StoreProxy()
            .destroy(row.storeSeq)
            .then((response) => {
              if(response.header.returnCode === "OK") {
                this.changeArea();
              } else {
                alert(response.header.resultMessages);
              }
            })
        }
      },
      searchStore() {
        let param = {
          searchAreaSeq: this.searchAreaSeq
        };
        this.$store.dispatch('store/findAll', param);
      },
      changeArea() {
        this.selectedStoreSeq = '';
        this.searchStore();
      },
      // 화면 초기화
      resetPage() {
        location.reload();
      },
      getDateText(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      // 권한 확인
      checkAuth(roleCode, targetRoles) {
        return Vue.checkAuth(roleCode, targetRoles);
      }
    },
    computed: {
      filterData() {
        return this.$store.state.store.stores.filter(function (store) {
          return this.selectedStoreSeq === '' || this.selectedStoreSeq === store.storeSeq;
        }, {selectedStoreSeq : this.selectedStoreSeq});
      },
    },
    data() {
      return {
        searchAreaSeq: '',
        modals: {
          isShow: false,
        },
        selectedStoreSeq: '',
        tableColumns: [
          {
            prop: 'storeName',
            label: '점포',
          },
          {
            prop: 'areaName',
            label: '지역',
          },
        ],
      }
    }
  }
</script>

<style scoped>

</style>
